var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mp-rating"
  }, [_vm.formattedRate && _vm.declOfReviewsCount ? [_c('p', {
    staticClass: "mp-rating__rate"
  }, [_vm._v("\n      " + _vm._s(_vm.formattedRate) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "mp-rating__reviews"
  }, [_vm._v("\n      " + _vm._s(_vm.declOfReviewsCount) + "\n    ")])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }